import { observable } from 'mobx';
import { useEffect, useRef } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import { getParameterByName, jumpPage } from '@src/utils/common-util.js';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();

class DownloadStore extends BaseStore {
  @observable isActive = false;

  @observable
  layerData = {
    download: {
      launcher_download_link:
        'https://ssg-tx-os.seasuncdn.com/ssglauncher/gp/Client/prod/Channel/MechaBREAKGP/SeasunGameInstaller-MechaBREAKGP-mechabreak_gp.exe',
      store_page_download_link: ''
    }
  };

  @observable isShowBackTop = false;

  installerQuestion = [
    {
      title: getLocales('download.FQA[0]'),
      link: {
        en: 'https://mechabreak.seasungames.com/show-1359-535-1.html',
        ja: 'https://mechabreak.seasungames.com/show-1359-543-1.html',
        ko: 'https://mechabreak.seasungames.com/show-1359-540-1.html',
        'zh-Hant': 'https://mechabreak.seasungames.com/show-1359-541-1.html',
        es: 'https://mechabreak.seasungames.com/show-1359-547-1.html',
        pt: 'https://mechabreak.seasungames.com/show-1359-559-1.html',
        de: 'https://mechabreak.seasungames.com/show-1359-548-1.html',
        fr: 'https://mechabreak.seasungames.com/show-1359-550-1.html',
        ru: 'https://mechabreak.seasungames.com/show-1359-553-1.html',
        th: 'https://mechabreak.seasungames.com/show-1359-555-1.html'
      }
    },
    {
      title: getLocales('download.FQA[1]'),
      link: {
        en: 'https://mechabreak.seasungames.com/show-1358-534-1.html',
        ja: 'https://mechabreak.seasungames.com/show-1358-539-1.html',
        ko: 'https://mechabreak.seasungames.com/show-1358-544-1.html',
        'zh-Hant': 'https://mechabreak.seasungames.com/show-1358-545-1.html',
        es: 'https://mechabreak.seasungames.com/show-1358-551-1.html',
        pt: 'https://mechabreak.seasungames.com/show-1358-554-1.html',
        de: 'https://mechabreak.seasungames.com/show-1358-556-1.html',
        fr: 'https://mechabreak.seasungames.com/show-1358-557-1.html',
        ru: 'https://mechabreak.seasungames.com/show-1358-558-1.html',
        th: 'https://mechabreak.seasungames.com/show-1358-560-1.html'
      }
    },
    {
      title: getLocales('download.FQA[2]'),
      link: {
        en: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/en/news-detail.html#/?contentId=sjm07gmhiww1',
        ja: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/ja/news-detail.html#/?contentId=sjm07gmhiww1',
        ko: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/ko/news-detail.html#/?contentId=sjm07gmhiww1',
        'zh-Hant': 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/zh-Hant/news-detail.html#/?contentId=sjm07gmhiww1',
        es: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/es/news-detail.html#/?contentId=sjm07gmhiww1',
        pt: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/pt/news-detail.html#/?contentId=sjm07gmhiww1',
        de: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/de/news-detail.html#/?contentId=sjm07gmhiww1',
        fr: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/fr/news-detail.html#/?contentId=sjm07gmhiww1',
        ru: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/ru/news-detail.html#/?contentId=sjm07gmhiww1',
        th: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/index/th/news-detail.html#/?contentId=sjm07gmhiww1'
      }
    }
  ];

  graphicsCardInstallerPackage = [
    {
      title: 'NVIDIA',
      icon: require(`./images/${lang}/NVIDIA.png`),
      link: {
        en: 'https://www.nvidia.com/en-us/drivers/',
        ja: 'https://www.nvidia.com/ja-jp/drivers/',
        ko: 'https://www.nvidia.com/ko-kr/drivers/',
        'zh-Hant': 'https://www.nvidia.com/zh-tw/drivers/',
        es: 'https://www.nvidia.com/es-es/drivers/',
        pt: 'https://www.nvidia.com/pt-br/drivers/',
        de: 'https://www.nvidia.com/en-eu/drivers/',
        fr: 'https://www.nvidia.com/fr-fr/drivers/',
        ru: 'https://www.nvidia.com/en-us/drivers/',
        th: 'https://www.nvidia.com/en-us/drivers/'
      }
    },
    {
      title: 'AMD',
      icon: require(`./images/${lang}/AMD.png`),
      link: {
        en: 'https://www.amd.com/en/support/download/drivers.html',
        ja: 'https://www.amd.com/ja/support/download/drivers.html',
        ko: 'https://www.amd.com/ko/support/download/drivers.html',
        'zh-Hant': 'https://www.amd.com/zh-tw/support/download/drivers.html',
        es: 'https://www.amd.com/es/support/download/drivers.html',
        pt: 'https://www.amd.com/pt/support/download/drivers.html',
        de: 'https://www.amd.com/de/support/download/drivers.html',
        fr: 'https://www.amd.com/fr/support/download/drivers.html',
        ru: 'https://www.amd.com/en/support/download/drivers.html',
        th: 'https://www.amd.com/en/support/download/drivers.html'
      }
    },
    {
      title: 'INTEL',
      icon: require(`./images/${lang}/INTEL.png`),
      link: {
        en: 'https://www.intel.com/content/www/us/en/download-center/home.html',
        ja: 'https://www.intel.co.jp/content/www/jp/ja/download-center/home.html',
        ko: 'https://www.intel.co.kr/content/www/kr/ko/download-center/home.html',
        'zh-Hant': 'https://www.intel.com.tw/content/www/tw/zh/download-center/home.html',
        es: 'https://www.intel.la/content/www/xl/es/download-center/home.html',
        pt: 'https://www.intel.com.br/content/www/br/pt/download-center/home.html',
        de: 'https://www.intel.de/content/www/de/de/download-center/home.html',
        fr: 'https://www.intel.fr/content/www/fr/fr/download-center/home.html',
        ru: 'https://www.intel.com/content/www/us/en/download-center/home.html',
        th: 'https://www.thailand.intel.com/content/www/th/th/download-center/home.html'
      }
    }
  ];

  /**
   * 返回官网首页/FAB/分流页，根据from参数判断
   * @returns {void}
   */
  back = () => {
    if (IS_DEV_ENV) {
      this.redirect('/');
    } else {
      jumpPage('index.html');
    }
  };

  onBackTop = () => {
    this.scrollBox.current.scrollTop = 0;
  };

  use() {
    super.use();
    const funlinkData = useFunLinkPageData();
    this.scrollBox = useRef(null);
    this.$globalStore.showNavbarDownloadBtn = false;

    useEffect(
      () => {
        if (funlinkData) {
          this.layerData = funlinkData;
        }
      },
      [funlinkData]
    );
    useMount(() => {
      this.isActive = true;

      this.scrollBox.current.addEventListener('scroll', e => {
        this.isShowBackTop = e.target.scrollTop > 100;
      });
    });
  }
}

export default DownloadStore;
